export default __webpack_public_path__ + "static/media/IconDesc_ThermalPropulsionRocket.256.21631044.png";